<template>
  <div class="text-main">
    <!-- <p class="title">隐私政策</p> -->
    <!-- <div class="block">
      <p class="two-title">第一部分：服务协议</p>
      <p class="common-p">
        欢迎您使用心潮科技的服务！
      </p>
      <p class="two-title">
        特别提醒：当您开始使用小睡眠服务时即代表您已阅读并决定接受《小睡眠服务协议》（“本协议”）。若您对本协议存在疑问，或者无法全部或者部分接受本协议，或者在使用小睡眠过程中需要向心潮科技反馈（含建议、投诉、举报等），请毫不迟疑地与心潮科技取得联系：邮箱：office@heartide.com。
      </p>
    </div>
    <div class="block">
      <p class="two-title">1.本协议及定义：</p>
      <p class="common-p">
        (1) 本协议是您与心潮科技之间关于您使用小睡眠相关服务所订立的协议。心潮科技可能根据自身对商业、适用法律与政策等要素的判断，随时更新本协议；若您无法接受本协议或本协议未来更新版本的全部或者部分条款，可联系心潮科技，在您未与心潮科技沟通一致前，请暂停使用小睡眠。<br/><br/>
        (2) 小睡眠：为心潮科技开发、运营、管理的一款小程序，旨在为您提供本协议范围内免费、非独占和全球范围内的软件使用许可及技术服务。本协议项下的“小睡眠”根据不同的语境将可能指小睡眠小程序或者心潮科技围绕小睡眠小程序提供的相关技术服务。<br/><br/>
        (3) 心潮科技：涉及（且仅在涉及）到心潮科技依据本协议可享有的权利时，本协议项中所指“心潮科技”指广州心与潮信息科技有限公司。<br/><br/>
        (4) 素材：指由心潮科技提供的已经内置于小睡眠的或者未来即将内置的包括但不限于音频、字体、文字、说明、动画等用于帮助您睡眠、放松等的相关素材与信息。
      </p>
    </div>
    <div class="block">
      <p class="two-title">2.知识产权声明：</p>
      <p class="common-p">
        小睡眠本身自带的所有版本、技术、程序、素材和所有的信息内容（信息内容，包括但不限于产品功能、用户界面、操作步骤、商标、专利、计算机软件作品）的知识产权均归心潮科技所有，心潮科技对您的软件使用许可在任何情况下均不应视为向您转让心潮知识产权的部分或者全部。您通过小睡眠下载、使用的任何素材及其他信息内容，仅限您个人娱乐、学习、研究、训练或者欣赏使用，未经心潮科技书面同意，不可用于任何商业用途。
      </p>
    </div>
    <div class="block">
      <p class="two-title">3.您的必要授权：</p>
      <p class="common-p">
        您同意授予心潮科技一项为提供本服务、优化本服务和宣传推广本服务之目的所必须的免费、非独占、不可撤销的可在全球范围内使用您在本服务过程中产生信息内容的权利。心潮科技将尽最大努力在合理范围内使用上述信息内容，且您的必要授权并不代表心潮科技对上述信息内容的必然使用。
      </p>
    </div>
    <div class="block">
      <p class="two-title">4.个人信息保护：</p>
      <p class="common-p">
        保护您的个人信息是心潮科技的一项基本原则。心潮科技将按照本协议规定收集、使用、存储和管理您的个人信息。
      </p>
    </div>
    <div class="block">
      <p class="two-title">5.您的合法使用：</p>
      <p class="common-p">
        您不得使用小睡眠制作、储存或发布如下信息内容：<br/><br/>
        (1) 危害国家及社会安全信息，其表现可能包括但不限于反对宪法所确定的基本原则；危害国家安全，泄露国家机密，颠覆国家政权，破坏国家统一；煽动民族仇恨、民族歧视，破坏民族团结；破坏国家宗教政策，宣扬邪教和封建迷信；散布谣言，扰乱社会秩序，破坏社会稳定；宣扬赌博、暴力、凶杀、恐怖或者教唆犯罪；煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；含有法律、行政法规和国家规定禁止的其他内容。<br/><br/>
        (2) 淫秽色情信息，其表现可能包括但不限于发布淫秽、色情内容，包括但不限于招嫖、寻找一夜情、性伴侣等内容；发布以色情为目的的情色文字、情色视频、情色图画等内容；长期发布与淫秽、色情内容擦边的或具有性暗示类的内容。<br/><br/>
        (3) 侵权信息，其表现可能包括但不限于制作、发布、储存侵犯他人名誉权、肖像权、隐私权、知识产权等合法权利的内容。<br/><br/>
        (4) 不正当竞争信息，其表现可能包括但不限于发布篡改、增减、删除权利标识的内容；发布未经授权方授权的内容等。<br/><br/>
        (5) 其他违反法律法规、政策以及社会公序良俗或干扰小睡眠正常运营及侵犯任何第三方合法权益的信息。<br/><br/>
        如您有上述违法或侵害他人合法权利的行为，心潮科技有权立即采取适当措施，包括但不限于：删除该等违法信息内容，终止对您的软件使用许可并停止所有技术服务，诉诸执法机构或司法机关等。若因您违法或不当使用小睡眠而造成的自身损失或对心潮科技和/或第三方造成损害的，您须自行承担所有责任。
      </p>
    </div>
    <div class="block">
      <p class="two-title">6.不可抗力与其他免责事由：</p>
      <p class="common-p">
        小睡眠在使用中会受到包括但不限于如下不可抗力或者其他因素的影响：政治原因、社会环境、自然灾害、经济危机、计算机病毒或黑客攻击、服务器或系统不稳定、您所在的特殊位置、任何技术能力、网络质量以及通信线路、计算机故障等（以下统称“免责事由”）。若出现上述免责事由情况时，心潮科技将尽努力在第一时间进行修复或者及时补救，给您造成损失的，心潮科技在适用法律与政策允许的范围内免责。      </p>
    </div>
    <div class="block">
      <p class="two-title">
        7.适用法律与政策：
      </p>
      <p class="common-p">
        与本协议有关的事项，均应适用中华人民共和国（但不含港澳台地区）的法律与政策。该等适用法律与政策可能处于动态变化过程中，因此，若因适用法律与政策发生变化，导致您和/或心潮科技在本协议项下的权益有所增减，均不构成本协议的全部或某个条款自然无效或终止可执行性的依据，除非发生变化的该等适用法律与政策属于效力性强制性规定。      </p>
    </div>
    <div class="block">
      <p class="two-title">
        8.法律纠纷管辖：
      </p>
      <p class="common-p">
        若在您与心潮科技之间出现了与本协议和/或与小睡眠有关的法律纠纷，只要发生纠纷时本协议适用法律与政策允许将广州心与潮信息科技有限公司所在地作为唯一或其中之一的纠纷管辖地的，则您同意由广州心与潮信息科技有限公司所在地有管辖权的人民法院排他管辖该纠纷。      </p>
    </div>
    <div class="block">
      <p class="two-title">第二部分：隐私权政策</p>
      <p class="two-title">我们非常重视您的隐私权。</p>
      <p class="common-p">
        心潮科技致力于保护用户隐私权。本隐私权政策旨在向您说明，在使用我们的服务时，我们如何收集、存储、使用和管理这些信息。这些信息包括您向我们提供的个人信息或者我们通过我们网站或者移动应用终端收集到的相关信息。收集途径主要包括：移动设备上（如：苹果设备和安卓设备）提供的心潮科技应用程序产品(“我们的服务”)。 使用我们的服务就意味着您同意本政策，并同意根据本政策中规定的方式对您的数据（包括您的个人信息）进行收集和处理。如果您不同意本政策及未来修订版本的任何条款，请不要使用服务。<br/>
        如对本政策或任何隐私权相关问题有任何疑问，请通过office@heartide.com与我们联系。
      </p>
    </div>
    <div class="block">
      <p class="two-title">我们可能收集的信息</p>
      <p class="common-p">
        为了向您提供更好的服务，我们将在法律允许的范围内和当且仅当您使用某些功能或者服务时，收集您的相关数据和信息。
      </p>
    </div>
    <div class="block">
      <p class="two-title">您使用服务时我们获取的信息</p>
      <p class="two-title">设备信息</p>
      <p class="common-p">
        当您在移动平台上使用任何心潮科技应用程序时，我们可能收集并记录某些信息，比如您的产品唯一身份标识（持续的／间断的）、硬件种类、介质访问控制（“MAC”）地址、您的操作系统（“OS”）版本、您设备的名称和您的位置（基于您的网络协议（“IP”）地址）。这一信息有助于我们解决问题并了解总体用户使用倾向。<br/><br/>
        我们可能收集您的位置信息以向您提供正确的应用程序版本及更优质的服务。除本政策另有约定外，我们不会与任何第三方分享这一信息。如果您不再希望我们跟踪或使用这一信息，您可以在设备上关闭网络、GPS功能或者禁用我们获取您网络、GPS、设备信息权限。<br/><br/>
        此外，我们可能创建了唯一用户身份标识以跟踪您对我们服务的使用。此唯一用户身份标识与您的个人资料信息储存在一起，以便于了解您正在使用的心潮科技应用程序。
      </p><br/>

      <p class="two-title">数据共享与披露</p>
      <p class="common-p">
        我们的小程序集成友盟+SDK，友盟+SDK需要收集您在小程序平台去标识化ID（如openid/unionid/userid）以及您设置的公开信息（昵称/头像/性别/地区/语言）以提供统计分析服务。
      </p><br/>

      <p class="two-title">使用日志</p>
      <p class="common-p">
        当您使用我们的服务，包括参与、生成、浏览与我们的服务相关的内容时，我们将会自动收集心潮科技应用内某些相关的日志信息，这些信息包括：(1)关于您的使用时间、使用频率等细节；(2)设备统计信息、关键操作路径、错误日志、崩溃记录、语言和时区等。这些日志信息能够帮助我们更好的了解和改善我们的服务，并非用于识别任何特定的个人。
      </p><br/>
      <p class="two-title">我们如何使用信息</p>
      <p class="common-p">
        我们收集用户信息是以提升服务质量与用户体验为目的，为了实现这一目的，我们可能将您的信息用于：
      </p>
      <p class="two-title">(一) 创建帐号；</p>
      <p class="two-title">(二) 运营及改善我们的服务；</p>
      <p class="two-title">(三) 回复您的评论与问题，并提供客户服务；</p>
      <p class="two-title">(四) 提供及交付您要求的产品与服务；</p>
      <p class="two-title">(五) 发送与您相关的信息，包括确认、技术通告、更新、安全警告、支持及行政信息；</p>
      <p class="two-title">(六) 为上述目的，在其他国家处理您的信息。</p>
    </div>
    <div class="block">
      <p class="common-p">除非下列情形发生时，我们无权披露您的全部或部分信息：</p>
      <p class="two-title">(一) 为保护他人的人身或财产安全；</p>
      <p class="two-title">(二) 为防止或解决网络欺诈；</p>
      <p class="two-title">(三) 维护心潮科技的合法权利及权益;</p>
      <p class="two-title">(四) 实现“我们可能收集的信息”部分所述目的，前提条件为该等披露接收方应同等接受本政策约束并可以提供信息充分保护；</p>
      <p class="two-title">(五) 根据法律、法规的规定，或遵从政府部门、司法机关的要求；通常前述要求都是为了保护网络安全和保护我们、我们的用户和第三方的权利、财产和安全。</p>
    </div>
    <div class="block">
      <p class="two-title">信息安全性</p>
      <p class="common-p">我们使用合理措施，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术来保护您提供的个人信息。但请您理解（在互联网行业）即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
    </div>
    <div class="block">
      <p class="two-title">信息访问与控制</p>
      <p class="common-p">我们将采取一切合理适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障帐号安全。</p>
    </div>
    <div class="block">
      <p class="two-title">数据保留</p>
      <p class="common-p">受限于法律法规要求，我们将按照“我们如何使用信息”章节或者为您提供服务的时间范围内保留您的信息。如果您希望删除您的帐号或者要求我们不得再使用您的信息为您提供服务，请发送电子邮件至office@heartide.com。</p>
    </div>
    <div class="block">
      <p class="two-title">儿童信息</p>
      <p class="common-p">我们不会有意向13周岁以下的人群收集或请求个人信息。如果您低于13周岁，请不要向我们发送您的个人信息，包括您的名字、地址、电话号码或者邮箱地址。如果您认为我们可能有13周岁以下儿童任何信息时，请发送电子邮件至office@heartide.com。</p>
    </div>

    <div class="block">
      <p class="common-p" style="text-align: right">广州心与潮信息科技有限公司</p>
      <p class="common-p" style="text-align: right">更新日期：2020年11月05日</p>
    </div> -->
      <h2 class="center">服务协议</h2>
        <p>发布时间：2020年11月05日</p>
        <p>生效时间：2020年11月05日</p>
        <p>更新时间：2021年12月25日</p>

        <h3 class="mt50">心潮科技用户服务协议</h3>
        <p>欢迎您使用心潮科技的服务！</p>
        <h3>特别提醒：当您开始使用小睡眠服务时即代表您已阅读并决定接受《小睡眠服务协议》（“本协议”）。若您对本协议存在疑问，或者无法全部或者部分接受本协议，或者在使用小睡眠过程中需要向心潮科技反馈（含建议、投诉、举报等），请毫不迟疑地与心潮科技取得联系：邮箱：office@heartide.com。</h3>
        <h3>1.本协议及定义：</h3>
        <p>(1) 本协议是您与心潮科技之间关于您使用小睡眠相关服务所订立的协议。心潮科技可能根据自身对商业、适用法律与政策等要素的判断，随时更新本协议；若您无法接受本协议或本协议未来更新版本的全部或者部分条款，可联系心潮科技，在您未与心潮科技沟通一致前，请暂停使用小睡眠。</p>
        <p>(2) 小睡眠：为心潮科技开发、运营、管理的一款应用软件产品，旨在为您提供本协议范围内免费、非独占和全球范围内的软件使用许可及技术服务。本协议项下的“小睡眠”根据不同的语境将可能指小睡眠移动端、小睡眠小程序、小睡眠独立网站或者心潮科技围绕小睡眠软件产品提供的相关技术服务。</p>
        <p>(3) 心潮科技：涉及（且仅在涉及）到心潮科技依据本协议可享有的权利时，本协议项中所指“心潮科技”指广州心与潮信息科技有限公司。</p>
        <p>(4) 素材：指由心潮科技提供的已经内置于小睡眠的或者未来即将内置的包括但不限于音频、字体、文字、说明、动画等用于帮助您睡眠、放松等的相关素材与信息。</p>
        <h3>2.知识产权声明：</h3>
        <p>小睡眠本身自带的所有版本、技术、程序、素材和所有的信息内容（信息内容，包括但不限于产品功能、用户界面、操作步骤、商标、专利、计算机软件作品）的知识产权均归心潮科技所有，心潮科技对您的软件使用许可在任何情况下均不应视为向您转让心潮知识产权的部分或者全部。您通过小睡眠下载、使用的任何素材及其他信息内容，仅限您个人娱乐、学习、研究、训练或者欣赏使用，未经心潮科技书面同意，不可用于任何商业用途。</p>
        <h3>3.您的必要授权：</h3>
        <p>您同意授予心潮科技一项为提供本服务、优化本服务和宣传推广本服务之目的所必须的免费、非独占、不可撤销的可在全球范围内使用您在本服务过程中产生信息内容的权利。心潮科技将尽最大努力在合理范围内使用上述信息内容，且您的必要授权并不代表心潮科技对上述信息内容的必然使用。</p>
        <h3>4.个人信息保护：</h3>
        <p>保护您的个人信息是心潮科技的一项基本原则。心潮科技将按照本协议规定收集、使用、存储和管理您的个人信息。</p>
        <h3>5.您的合法使用：</h3>
        <p>您不得使用小睡眠制作、储存或发布如下信息内容：</p>
        <p>(1) 危害国家及社会安全信息，其表现可能包括但不限于反对宪法所确定的基本原则；危害国家安全，泄露国家机密，颠覆国家政权，破坏国家统一；煽动民族仇恨、民族歧视，破坏民族团结；破坏国家宗教政策，宣扬邪教和封建迷信；散布谣言，扰乱社会秩序，破坏社会稳定；宣扬赌博、暴力、凶杀、恐怖或者教唆犯罪；煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；含有法律、行政法规和国家规定禁止的其他内容。</p>
        <p>(2) 淫秽色情信息，其表现可能包括但不限于发布淫秽、色情内容，包括但不限于招嫖、寻找一夜情、性伴侣等内容；发布以色情为目的的情色文字、情色视频、情色图画等内容；长期发布与淫秽、色情内容擦边的或具有性暗示类的内容。</p>
        <p>(3) 侵权信息，其表现可能包括但不限于制作、发布、储存侵犯他人名誉权、肖像权、隐私权、知识产权等合法权利的内容。</p>
        <p>(4) 不正当竞争信息，其表现可能包括但不限于发布篡改、增减、删除权利标识的内容；发布未经授权方授权的内容等。</p>
        <p>(5) 其他违反法律法规、政策以及社会公序良俗或干扰小睡眠正常运营及侵犯任何第三方合法权益的信息。</p>
        <p>如您有上述违法或侵害他人合法权利的行为，心潮科技有权立即采取适当措施，包括但不限于：删除该等违法信息内容，终止对您的软件使用许可并停止所有技术服务，诉诸执法机构或司法机关等。若因您违法或不当使用小睡眠而造成的自身损失或对心潮科技和/或第三方造成损害的，您须自行承担所有责任。</p>
        <h3>6.广告业务许可：</h3>
        <p>小睡眠中可能包括广告，这属于心潮科技合理合法的商业模式，您同意在使用小睡眠过程中接收由心潮科技与第三方合作伙伴发布的广告信息。</p>
        <h3>7.不可抗力与其他免责事由：</h3>
        <p>小睡眠在使用中会受到包括但不限于如下不可抗力或者其他因素的影响：政治原因、社会环境、自然灾害、经济危机、计算机病毒或黑客攻击、服务器或系统不稳定、您所在的特殊位置、任何技术能力、网络质量以及通信线路、计算机故障等（以下统称“免责事由”）。若出现上述免责事由情况时，心潮科技将尽努力在第一时间进行修复或者及时补救，给您造成损失的，心潮科技在适用法律与政策允许的范围内免责。</p>

        <h3>8.适用法律与政策：</h3>
        <p>与本协议有关的事项，均应适用中华人民共和国（但不含港澳台地区）的法律与政策。该等适用法律与政策可能处于动态变化过程中，因此，若因适用法律与政策发生变化，导致您和/或心潮科技在本协议项下的权益有所增减，均不构成本协议的全部或某个条款自然无效或终止可执行性的依据，除非发生变化的该等适用法律与政策属于效力性强制性规定。</p>
        <h3>9.法律纠纷管辖：</h3>
        <p>若在您与心潮科技之间出现了与本协议和/或与小睡眠有关的法律纠纷，只要发生纠纷时本协议适用法律与政策允许将广州心与潮信息科技有限公司所在地作为唯一或其中之一的纠纷管辖地的，则您同意由广州心与潮信息科技有限公司所在地有管辖权的人民法院排他管辖该纠纷。</p>
        <p>心潮科技可能不时发布针对用户的相关协议，并可能将该相关协议作为对本协议的补充或修改而将其内容作为本协议的一部分。请您及时关注并阅读相关协议。</p>
        <p>本协议任意一条被视为废止、无效或不可执行，该条款应视为可分的且不影响本协议其他条款的法律效力。</p>
        <p>请您再次确认您已全部阅读并充分理解上述协议。</p>
        <p class="mt30 fwb right">广州心与潮信息科技有限公司</p>
        <p class="fwb right">2021年12月25日</p>
  </div>
</template>

<script>
export default {
  name: 'iosyinsi',
  mounted () {
    document.title = '服务协议'
  }
}
</script>

<style lang="scss" scoped>
.iosyinsi {
  font-size: px2html(14px);
  box-sizing: border-box;
  margin-top: px2html(20px);
  padding-left: px2html(21px);
  padding-right: px2html(18px);
  .title {
    font-size: px2html(16px);
    font-weight: 900;
    margin-bottom: px2html(28px);
  }
  .block {
    margin-bottom: px2html(28px);
  }
  .two-title {
    font-weight: 700;
    text-align: left;
    margin-bottom: px2html(14px);
  }
  .common-p {
    text-align: left;
    margin-bottom: 7px;
  }
}
</style>
